const dateTypes = {
  section: "Datas",
  values: [
    "DATA_YYYY_MM_DD",
    "DATA_YYYYMMDD",
    "DATA_DD_MM_AAAA",
    "DATA_DDMMAAAA",
    "DATA_DD_MM_AA",
    "DATA_MM_DD_AA",
    "DATA_MMM_DD_YYYY",
    "DATA_DD_MMM_YYYY",
    "DATA_DD_MMMM_YYYY",
    "DATA_DD_MM_AAAA_DASH",
  ],
};

const datetimeTypes = {
  section: "Data e Hora",
  values: ["DATA_HORA", "DATA_HORA_T"],
};

const competenceTypes = {
  section: "Competência",
  values: ["DATA_MM_AAAA", "DATA_MMAAAA", "DATA_AAAAMM", "DATA_AAAA_MM", "DATA_AAAA_MM_DASH", "DATA_MM_AAAA_DASH"],
};

const documentTypes = {
  section: "Documentos",
  values: ["CPF_FORMATADO"],
};

const numberIntTypes = {
  section: "Números e Texto",
  values: ["NUMERO"],
};

const numberFloatTypes = {
  section: "Números e Texto",
  values: ["DECIMAL"],
};

const textTypes = {
  section: "Números e Texto",
  values: ["TEXTO"],
};

const timeTypes = {
  section: "Data e Hora",
  values: ["HORA", "HORA_A"],
};

export const allowedTypesByColumn = {
  DATA_INICIO: {
    sections: [
      dateTypes.section,
      competenceTypes.section,
      datetimeTypes.section,
      timeTypes.section,
    ],
    options: [
      ...dateTypes.values,
      ...competenceTypes.values,
      ...datetimeTypes.values,
      ...timeTypes.values,
    ],
    defaultValue: 'DATA_DDMMAAAA'
  },
  DATA_FIM: {
    sections: [
      dateTypes.section,
      competenceTypes.section,
      datetimeTypes.section,
      timeTypes.section,
    ],
    options: [
      ...dateTypes.values,
      ...competenceTypes.values,
      ...datetimeTypes.values,
      ...timeTypes.values,
    ],
    defaultValue: 'DATA_DDMMAAAA'
  },
  FUNCIONARIO_FOLHA: {
    sections: [numberIntTypes.section],
    options: [...numberIntTypes.values],
    defaultValue: 'NUMERO',
  },
  PIS: {
    sections: [numberIntTypes.section],
    options: [...numberIntTypes.values, ...textTypes.values],
    defaultValue: 'NUMERO',
  },
  CPF: {
    sections: [documentTypes.section, numberIntTypes.section],
    options: [...documentTypes.values, ...numberIntTypes.values,],
    defaultValue: 'CPF_FORMATADO',
  },
  NOME_FUNCIONARIO: {
    sections: [textTypes.section],
    options: [...textTypes.values],
    defaultValue: 'TEXTO',
  },
  DEPARTAMENTO: {
    sections: [textTypes.section],
    options: [...textTypes.values],
    defaultValue: 'TEXTO',
  },
  DEPARTAMENTO_FOLHA: {
    sections: [numberIntTypes.section],
    options: [...numberIntTypes.values],
    defaultValue: 'NUMERO',
  },
  EMPRESA_FOLHA: {
    sections: [numberIntTypes.section],
    options: [...numberIntTypes.values],
    defaultValue: 'NUMERO',
  },
  FUNCAO: {
    sections: [textTypes.section],
    options: [...textTypes.values],
    defaultValue: 'TEXTO',
  },
  DOCUMENTO_EMP: {
    sections: [numberIntTypes.section, documentTypes.section],
    options: [...numberIntTypes.values, ...documentTypes.values, ...textTypes.values],
    defaultValue: 'NUMERO',
  },
  NOME_EMPRESA: {
    sections: [textTypes.section],
    options: [...textTypes.values],
    defaultValue: 'TEXTO',
  },
  CODIGO_RUBRICA: {
    sections: [numberIntTypes.section],
    options: [...numberIntTypes.values, ...numberFloatTypes.values, ...textTypes.values],
    defaultValue: 'NUMERO',
  },
  DATA_EVENTO: {
    sections: [
      dateTypes.section,
      datetimeTypes.section,
    ],
    options: [
      ...dateTypes.values,
      ...datetimeTypes.values,
    ],
    defaultValue: 'DATA_DDMMAAAA'
  },
  VALOR: {
    sections: [
      numberIntTypes.section,
      numberFloatTypes.section,
      textTypes.section,
    ],
    options: [
      ...numberIntTypes.values,
      ...numberFloatTypes.values,
      ...textTypes.values,
    ],
    defaultValue: 'NUMERO'
  },
  TEXTO_FIXO: {},
};

export const filterSectionsByColumnType = (selectedColumn, options) => {
  const allowedTypes = allowedTypesByColumn[selectedColumn];

  if (allowedTypes?.options) {
    const filteredOptions = options.filter((item) =>
      allowedTypes.options.includes(item.value)
    );

    return filteredOptions;
  }

  return options;
};